import { request } from './request'

export function GET_INDEX_LIST(data){
    return request({
        url:'/sites/g.it',
        method:'POST',
        params:data
    })
}
// 详情页面的
export function GET_DETAILS_LIST(Ddata){
    return request({
        url:'/sites/g.it',
        method:'POST',
        params:Ddata
    })
}